import { useContext, useEffect, useState } from "react";
import { flushSync } from "react-dom";
import { Contexto } from "@Componentes/App";
import * as _api_ from "@Funciones/api";
import * as _f_ from "@Funciones/funciones";
import * as _ipt_ from "@Elementos/Input";
import * as _btn_ from "@Elementos/Boton";
import * as _anim_ from "@Elementos/Animaciones";
import * as _tabla_ from "@Elementos/Tabla";
import * as _form_ from "@Elementos/Formulario";
import * as _opt_ from "@Elementos/Opciones";
import * as _div_ from "@Elementos/Div";
import * as _txta_ from "@Elementos/TextArea";
import * as _lul_ from "@Utilitarios/Listados/ListaUL";
import * as _preconf_ from "@Utilitarios/PreConfirmacion/PreConfirmacion";
import * as _posconf_ from "@Utilitarios/PostConfirmacion/PostConfirmacion";
import * as _procAcc_ from "@Utilitarios/ProcesandoAccion/ProcesandoAccion";

import Filtros from "@Composicion/Filtros/Filtros";
import ModalInformacion from "@ModalInformacion/ModalInformacion";
import * as _testing_ from "@Funciones/testing";
import "./MEliminarMaestro.css";

function MEliminarMaestro({
  origenComponente,
  registro,
  datosComplementarios,
  parametros,
  tipoEvento,
  fCerrarComponente,
  fEstablecerVariablesTabla,
  fActualizarTablaTotal,
}) {
  const { ecv_u, cv_u } = useContext(Contexto);
  const [v_u, ev_u] = useState({
    procesandoAPI: false,
    exitoAPI: false,
  });

  useEffect(() => {
    // fCerrarComponentePadre?.();
    console.log(origenComponente, registro, parametros, tipoEvento, datosComplementarios);
  }, []);
  return (
    <div>
      {v_u.exitoAPI && (
        <_posconf_.PostConfirmacion
          texto={`Se eliminó con éxito la relación del maestro: "${registro?.["Nombre"]}"`}
          fBotonDeAcuerdo={() => {
            fCerrarComponente?.();
            fActualizarTablaTotal?.(true);
          }}
        />
      )}
      {v_u.exitoAPI ? (
        <></>
      ) : v_u.procesandoAPI ? (
        <_procAcc_.ProcesandoAccion />
      ) : (
        <div>
          <div className={"MEliminarMaestroCSS-texto"}>
            <_div_.Div
              texto={`Seguro que desea eliminar la relación del maestro "${registro?.["Nombre"]}"
            con el producto "${datosComplementarios?.Producto}"`}
            />
          </div>
          <div className={"MEliminarMaestroCSS-opciones"}>
            <_btn_.Boton
              texto={`Aceptar`}
              tipo="btn-2"
              estilos={{
                anchoB2: "7rem",
                color: "var(--color_verde_1)",
                fuente: "1rem",
              }}
              onClick={() => {
                _f_.asignar(ev_u, { procesandoAPI: true });
                _f_.asignar(fEstablecerVariablesTabla, {
                  d_registroEventoTitulo: "⏳ Procesando",
                });

                const eliminarDatosAPI = _api_.f_RelacionMaestrosPPCRUD({
                  parametros: {
                    modo: "DEL",
                    codigoMaestro: registro?.codigoMaestro,
                    codigoPP: registro?.codigoPP,
                    datos: "",
                  },
                  origen: origenComponente,
                  timeout: 5000,
                });
                eliminarDatosAPI.respuesta.then((dPC) => {
                  _f_.asignar(ecv_u, dPC, true, origenComponente);
                  console.log(dPC);
                  if (!dPC.error) {
                    _f_.asignar(ev_u, { exitoAPI: true });
                    _f_.asignar(fEstablecerVariablesTabla, {
                      d_registroEventoTitulo: "✅ éxito",
                    });
                  } else {
                    fCerrarComponente?.();
                  }
                });
                // setTimeout(() => {
                //   _f_.asignar(ev_u, { exitoAPI: true });
                //   _f_.asignar(fEstablecerVariablesTabla, {
                //     d_registroEventoTitulo: "✅ éxito",
                //   });
                //   //
                // }, 3000);
              }}
            />
            <_btn_.Boton
              texto={`cancelar`}
              tipo="btn-2"
              estilos={{
                anchoB2: "7rem",
                color: "var(--color_rojo_1)",
                fuente: "1rem",
              }}
              onClick={() => {
                fCerrarComponente?.();
              }}
            />
          </div>
        </div>
      )}
    </div>
  );
}
export default MEliminarMaestro;
